import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { 
  getAuth, 
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
} from 'firebase/auth';
import { 
  getFirestore
} from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { initializeFirebaseErrorHandling } from "./firebase-error-handler";

// Initialize error handling early
initializeFirebaseErrorHandling();

// Ensure the app is initialized (modular guard for hybrid/vanilla-React coexistence)
let app: FirebaseApp;
const firebaseConfig = {
  apiKey: import.meta.env.VITE_apiKey,
  authDomain: import.meta.env.VITE_authDomain,
  projectId: import.meta.env.VITE_projectId,
  storageBucket: import.meta.env.VITE_storageBucket,
  messagingSenderId: import.meta.env.VITE_messagingSenderId,
  appId: import.meta.env.VITE_appId,
  measurementId: import.meta.env.VITE_measurementId,
};

if (getApps().length) {
  app = getApp();
} else {
  // Only initialize if not already initialized by compat
  app = initializeApp(firebaseConfig);
}

// Initialize and export Firebase services
export const auth = getAuth(app);

// Get Firestore instance - uses default database in whichever project is configured
// The region is determined by the Firebase project (VITE_projectId), not a named database
export const db = getFirestore(app);

export const storage = getStorage(app);

export { 
  app,
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
};

export default { 
  app,
  auth, 
  db, 
  storage, 
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
};
